import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { label: '首頁', href: '/' },
    { label: '產品系列', href: '/category' },
    { label: '健康資訊', href: '/articles' },
    { label: '關於我們', href: '/about' },
  ];

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className={`font-heading text-xl md:text-2xl font-semibold ${
              isScrolled ? 'text-primary-600' : 'text-primary-600'
            }`}>
              性福寶
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8" aria-label="主要導航">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  isActive(link.href)
                    ? 'text-primary-600'
                    : isScrolled
                      ? 'text-foreground-700 hover:text-primary-600'
                      : 'text-foreground-900 hover:text-primary-600'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#cta"
              className="bg-primary-500 text-background-50 px-5 py-2 rounded-md text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即訂購
            </a>
          </nav>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-800"
            aria-label="開啟選單"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <nav className="flex flex-col px-4 py-4 gap-3" aria-label="手機導航">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium py-2 whitespace-nowrap cursor-pointer ${
                  isActive(link.href) ? 'text-primary-600' : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="#cta"
              className="bg-primary-500 text-background-50 px-5 py-2.5 rounded-md text-sm font-medium text-center whitespace-nowrap cursor-pointer"
            >
              立即訂購
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}

export default Navbar;